import { combineEpics, ofType } from 'redux-observable'
import { from, of } from 'rxjs'
import { catchError, filter, map, mapTo, mergeMap } from 'rxjs/operators'

import { GlobalStore } from '@driftt/traffic-control'

import * as RoutingAPI from 'api/rules'

import * as actions from './actions'
import * as constants from './constants'
import * as selectors from './selectors'
import save from './treeSaver'

const startSaveDraft = (action$) => {
  return action$.pipe(
    ofType(constants.SAVE_DRAFT),
    filter(() => selectors.draftIsDirty(GlobalStore.getState())),
    mapTo({ type: constants.START_DRAFT_SAVE })
  )
}

const publishDraft = (action$) =>
  action$.pipe(
    ofType(constants.START_DRAFT_SAVE),
    mergeMap(() =>
      from(
        save({
          draft: selectors.draftRoot(GlobalStore.getState()),
          published: selectors.publishedRoot(GlobalStore.getState()),
        })
      ).pipe(
        map(actions.draftPublished),
        catchError((err) => of(actions.draftSaveFailed(err)))
      )
    )
  )

const refreshRulesAndGroups = (action$) =>
  action$.pipe(
    ofType(constants.DRAFT_PUBLISHED),
    mergeMap(() =>
      from(
        Promise.all([RoutingAPI.getAllRules(), RoutingAPI.getRuleGroups()])
      ).pipe(
        map(([{ rules, defaultRule }, { data }]) =>
          actions.draftSaveDone({
            rules,
            ruleGroups: data,
            defaultRuleUsers: defaultRule.userIds,
          })
        )
        // TODO: error state
      )
    )
  )

export default combineEpics(startSaveDraft, publishDraft, refreshRulesAndGroups)
